import NoResultsCompaniesIcon from '@clearkit/icons/glyphs/NoResultsCompanies';
import NoResultsPeopleIcon from '@clearkit/icons/glyphs/NoResultsPeople';
import { CKButton } from '@clearkit/react';
import { Link } from 'react-router-dom';

import paths from '~/lib/paths';
import { readableSegmentType } from '~/lib/segments';

const HELP_CENTER_URL =
  'https://help.clearbit.com/hc/en-us/articles/360023927853-Getting-started-with-Segments';

const SEGMENT_TYPE_COMPANY = 'Company';
const SEGMENT_TYPE_PERSON = 'Person';

const icons = {
  [SEGMENT_TYPE_COMPANY]: (
    <NoResultsCompaniesIcon width={40} height={40} className="text-gray-200" />
  ),
  [SEGMENT_TYPE_PERSON]: (
    <NoResultsPeopleIcon width={40} height={40} className="text-gray-200" />
  ),
};

const EmptySegmentHeadline = ({ segmentType }) => (
  <h1 className="mt-3 mb-1 text-base font-medium text-gray-600">
    There are no {readableSegmentType(segmentType)} matching this segment.
  </h1>
);

EmptySegmentHeadline.propTypes = {
  segmentType: PropTypes.oneOf([SEGMENT_TYPE_COMPANY, SEGMENT_TYPE_PERSON]),
};

const EmptySegmentPlaceholder = ({ segmentType, segmentId }) => (
  <div className="flex flex-col items-center text-center w-xxs">
    {icons[segmentType]}
    <EmptySegmentHeadline segmentType={segmentType} />
    <p className="px-4 mb-4 text-sm text-gray">
      Try editing the conditions for this segment or head to our{' '}
      <a
        href={HELP_CENTER_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="outline-none ck-link">
        help center
      </a>{' '}
      to learn more.
    </p>
    <CKButton as={Link} to={paths.segmentEdit(segmentType, segmentId)} isSmall>
      Edit segment
    </CKButton>
  </div>
);

EmptySegmentPlaceholder.propTypes = {
  segmentType: PropTypes.oneOf([SEGMENT_TYPE_COMPANY, SEGMENT_TYPE_PERSON]),
  segmentId: PropTypes.string,
};

export default EmptySegmentPlaceholder;
